<template>
  <div class="notfound">
  　<p class="notfound-title">Page is not found!</p>
    <img class="notfound-img" src="../assets/img/nazuna_404_.png" alt="">

    <div class="text-center">
      <router-link to="/home">
        <btn size="normal" type="cancel" label="HOME"></btn>
      </router-link>
    </div>
  </div>
</template>

<script>
import Btn from '../components/Button.vue'
import axios from 'axios'

export default {
  name: '404',

  components: {
    Btn,
  },

  data() {
    return {
    }
  },

  methods: {
  }
}

</script>

<style scoped>

.notfound {
  background: #f3983b;
  height: 100vh;
  z-index: -1;
}

.notfound-img {
  width: 80%;
  height: auto;
  margin: 20px auto;
  display: block;
  -webkit-animation: fuwafuwa 3s ease infinite;
  animation: fuwafuwa 3s ease infinite;
}

.notfound-title {
  width: 80%;
  padding-top: 40px;
  margin: auto;
  text-align: center;
  font-size: 26px;
  color: #fff;
  font-weight: 800;
}

@keyframes fuwafuwa {
  0% { transform:translateY(0) }
  5% { transform:translateY(0) }
  10% { transform:translateY(0) }
  20% { transform:translateY(-15px) }
  25% { transform:translateY(0) }
  30% { transform:translateY(-15px) }
  50% { transform:translateY(0) }
  100% { transform:translateY(0) }
}

@media screen and (min-width: 600px){
}
</style>
